



















































































import { Vue, Component } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import { mapState } from "vuex";
import sortKeys from "sort-keys";
import { db } from "../firebase";
import Graph from "../components/Graph.vue";

import { CondorcetModel, UninominalModel } from "../models/Result";

@Component({
  components: {
    Graph
  }
})
export default class PollResult extends Vue {
  uninominal: object | null = null;
  condorcet: object | null = null;
  answers: object | null = null;

  @State(state => state.app.featureFlipping) featureFlipping: any;

  async created() {
    const resultsRef = db
      .collection("polls")
      .doc(this.$route.params.id)
      .collection("results");
    try {
      const uninominal: any = (await resultsRef.doc("uninominal").get()).data();
      this.uninominal = uninominal.ranking;

      const condorcet: any = (await resultsRef.doc("condorcet").get()).data();

      const condorcetMatrix = Object.keys(condorcet.matrix).reduce(
        (acc, key) => ({
          ...acc,
          [key]: {
            duels: {
              ...condorcet.matrix[key].duels,
              [key]: "/"
            },
            value: condorcet.matrix[key].value
          }
        }),
        {}
      );

      this.condorcet = {
        ranking: condorcet.ranking,
        matrix: sortKeys(condorcetMatrix, { deep: true })
      };

      this.answers = condorcet.ranking
        .map((c: any) => ({ value: c.value, slug: c.slug }))
        .sort((a: any, b: any) => {
          return a.slug.localeCompare(b.slug);
        });
    } catch (error) {
      return;
    }
  }
}
